/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mod_Exp_TitleInputs */

const es_landing_mod_exp_title = /** @type {(inputs: Landing_Mod_Exp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte la salida, comparte el gasto`)
};

const gl_landing_mod_exp_title = /** @type {(inputs: Landing_Mod_Exp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte a saída, comparte o gasto`)
};

const en_landing_mod_exp_title = /** @type {(inputs: Landing_Mod_Exp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share the trip, share the cost`)
};

/**
* | output |
* | --- |
* | "Share the trip, share the cost" |
*
* @param {Landing_Mod_Exp_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_mod_exp_title = /** @type {((inputs?: Landing_Mod_Exp_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mod_Exp_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_mod_exp_title(inputs)
	if (locale === "en") return en_landing_mod_exp_title(inputs)
	return es_landing_mod_exp_title(inputs)
});